/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-Optimizer
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface YtdTaxMetricsRequest
 */
export interface YtdTaxMetricsRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof YtdTaxMetricsRequest
     */
    accountGuids: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof YtdTaxMetricsRequest
     */
    tradeDateOverride?: string;
}

/**
 * Check if a given object implements the YtdTaxMetricsRequest interface.
 */
export function instanceOfYtdTaxMetricsRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "accountGuids" in value;

    return isInstance;
}

export function YtdTaxMetricsRequestFromJSON(json: any): YtdTaxMetricsRequest {
    return YtdTaxMetricsRequestFromJSONTyped(json, false);
}

export function YtdTaxMetricsRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): YtdTaxMetricsRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'accountGuids': json['account_guids'],
        'tradeDateOverride': !exists(json, 'trade_date_override') ? undefined : json['trade_date_override'],
    };
}

export function YtdTaxMetricsRequestToJSON(value?: YtdTaxMetricsRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'account_guids': value.accountGuids,
        'trade_date_override': value.tradeDateOverride,
    };
}

